import type { Column } from '@/components/Organisms/DataTable/DataTable.types';

export const fileTypeFilterOptions = [
	{ label: 'All', value: '' },
	{ label: 'CSV', value: 'CSV' },
	{ label: 'EXCEL', value: 'XLSX' },
	{ label: 'DOCX', value: 'DOCX' },
	{ label: 'PDF', value: 'PDF' },
	{ label: 'JPG', value: 'JPG' },
	{ label: 'PNG', value: 'PNG' },
	{ label: 'JPEG', value: 'JPEG' },
];

export const documentColumns: Column[] = [
	{
		key: 'name',
		label: 'Name',
		width: '200px',
		type: 'string',
		sorter: true,
		hideFilterBy: true,
	},
	{
		key: 'modifiedOn',
		label: 'Last edit',
		width: '80px',
		type: 'date',
		sorter: true,
		hideFilterBy: true,
	},
	{
		key: 'type',
		label: 'Type',
		width: '70px',
		type: 'string-status',
		hideColumnFilter: true,
	},
];
